import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Home } from "./home";
import { Pagina404 } from "./pagina404";
import { CustomFooter } from "../componentes/footer";
import { Pilotos } from "../navegacion/pilotos";
import { Calendarios } from "./calendarios";
import { Resultados } from "./resultados";
import { Reglamentos } from "./reglamentos";
import { HomeAsociacion } from "./homeAsociacion";
import { TerminosCondiciones } from "./terminosycondiciones";
import { PoliticasPrivacidad } from "./politicasprivacidad";
import { AccesoInterno } from "../navegacionInterna/accesoInterno";
import { AlertasGenerales } from "../componentes/alertas";
import { Login } from "../navegacionInterna/login";
import { CompRutasAdm } from "./rutasAdministracion";
import { SesionProvider } from "./userContexto";
import { HomePrueba } from "./LOVIEJODELHOME";
import { ResetearContraseña } from "./resetearContraseña";
import { Promocion } from "./promocion";

// Al cambiar de página vuelve arriba (si no, el navegador deja el scroll donde estaba, por ejemplo en el footer)
const VolverArriba = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

export const CompRutas = () => {
    const [alerta, setAlerta] = useState(null);
    // Protección de rutas para administradores
    const ProtectedRoute = ({ children }) => {
        const token = localStorage.getItem("administradoresSessionToken");
        if (!token) {
            return <Navigate to="/login" replace />;
        } else {
            return children;
        }
    };

    // Protección de rutas para pilotos
    const ProtectedRoutePilotos = ({ children }) => {
        const token = localStorage.getItem("pilotosSessionToken");
        if (!token) {
            return <Navigate to="/signin" replace />;
        } else {
            return children;
        }
    };

    // Redirección si el usuario ya está logueado
    const YaLogueado = ({ children }) => {
        const token = localStorage.getItem("administradoresSessionToken");
        if (token) {
            return <Navigate to="/admin" replace />;
        } else {
            return children;
        }
    };

   

    return (
        <BrowserRouter>
            <VolverArriba />
            <Routes>
                {/* Rutas principal */}
                <Route path="*" element={<Pagina404 />} />
                <Route path="/" element={<Home setAlerta={setAlerta} />} />
                <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
                <Route path="/politicas-de-privacidad" element={<PoliticasPrivacidad />} />
                <Route path="/promocion" element={<Promocion />} />


                {/* <Route path="/home" element={<HomePrueba />} /> */}
                <Route path="/:siglas" element={<HomeAsociacion />} />
                <Route path="/pilotos/:id_asociacion" element={<Pilotos />}/>
                <Route path="/reset-password" element={<ResetearContraseña setAlerta={setAlerta} />} />

                {/* Rutas internas */}
                {/* <Route path="/accesoInterno" element={<YaLogueado><AccesoInterno /></YaLogueado>} /> */}
                <Route path="/login" element={<YaLogueado><Login setAlerta={setAlerta}/></YaLogueado>} />
                <Route
                    path="/admin/*"
                    element={
                        <ProtectedRoute>
                            <SesionProvider>
                                <CompRutasAdm />
                            </SesionProvider>
                        </ProtectedRoute>
                    }
                />
            </Routes>
                    <AlertasGenerales inAlerta={alerta}/>
            {/* Footer condicional */}
        </BrowserRouter>
    );
};